export default function parseURL(url) {
	const parser = document.createElement('a');
	const searchObject = {};
	let field;
	let value;

	// Let the browser do the work
	parser.href = url;
	// Convert query string to object
	const queries = parser.search.replace(/^\?/, '').split('&');
	for (let i = 0; i < queries.length; i += 1) {
		[field, value] = queries[i].split('=');
		searchObject[field] = value;
	}
	return {
		protocol: parser.protocol,
		host: parser.host,
		hostname: parser.hostname,
		port: parser.port,
		pathname: parser.pathname,
		search: parser.search,
		searchObject,
		hash: parser.hash,
	};
}
